import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes
} from "react-router-dom";
import React, { useContext, useState } from 'react';
import './App.css';
import Loading from './component/loading';
import { GlobalContext } from "./context/provider";
import Login from "./component/login";
import Home from "./component/home";
import { BiLogOut } from "react-icons/bi";
import { AiOutlineMenu } from "react-icons/ai";
import Menu from "./component/menu";
import User from "./pages/user/user";
import Expensetype from "./pages/expensetype/expensetype";
import Expense from "./pages/expense/expense";
import Category from "./pages/category/category";
import Company from "./pages/company/company";
import Item from "./pages/item/item";
import Buy from "./pages/buy/buy";
import Sell from "./pages/sell/sell";
import Buyinvoice from "./pages/buyinvoice/buyinvoice";
import Report from "./pages/report/report";
import Broke from "./pages/broke/broke";
import Barcode from "./pages/barcode/barcode";
import './component/css/onprintcss.css';
import Returnbybarcode from "./pages/returnbybarcode/returnbybarcode";
import Return_item_company from "./pages/return_item_company/return_item_company";
import Deleteditem from "./pages/deleteditem/deleteditem";
import Customer from "./pages/customer/customer";
import Service from "./pages/service/service";
import Expireitem from "./pages/expireitem/expireitem";
import Customerledger from "./pages/customer/customerledger";
import Companyledger from "./pages/company/companyledger";


function App() {
  const { initState, initDispatch, clear } = useContext(GlobalContext);
  const [hide_menu, sethide_menu] = useState(true);
  return (
    <Router>
      {initState.loading ? <Loading /> :
        initState.islogin && initState.token != null ?
          <div className="w-full h-screen flex" dir="rtl">
            <div
              className={`static ${hide_menu ? "hidden" : "block"} 
                w-full md:w-96 h-full bg-white z-50 border-r border-gray-400
                transition-transform duration-300 ease-in-out
                absolute md:relative
                ${hide_menu ? "translate-x-full" : "translate-x-0"}
              `}
            >
              <Menu hide_menu={hide_menu} sethide_menu={sethide_menu} />
            </div>
            <div className={hide_menu ? "w-full h-full" : "w-full max-h-[100vh] overflow-y-hidden"}>
              <div className="w-full h-16 border-b-2 flex md:justify-between justify-between items-center px-10 print_hide">
                <AiOutlineMenu size={30} className="cursor-pointer" onClick={() => {
                  sethide_menu(!hide_menu);
                }} />
                <BiLogOut size={30} className="cursor-pointer" onClick={() => { clear() }} />
              </div>
              <Routes>
                <Route path="/" element={<Expireitem />} />
                <Route path="/returnitemtocompany" element={<Return_item_company />} />
                <Route path="/broke" element={<Broke />} />
                <Route path="/category" element={<Category />} />
                <Route path="/company" element={<Company />} />
                <Route path="/company/ledger" element={<Companyledger />} />
                <Route path="/customer" element={<Customer />} />
                <Route path="/customer/ledger" element={<Customerledger />} />
                <Route path="/item" element={<Item />} />
                <Route path="/service" element={<Service />} />
                <Route path="/removeditem" element={<Deleteditem />} />
                <Route path="/buy" element={<Buy />} />
                <Route path="/sell" element={<Sell />} />
                <Route path="/returnbybarcode" element={<Returnbybarcode />} />
                <Route path="/buyinvoice" element={<Buyinvoice />} />
                <Route path="/barcode" element={<Barcode />} />
                <Route path="/expensetype" element={<Expensetype />} />
                <Route path="/expense" element={<Expense />} />
                {
                  initState?.token?.role == "admin" &&
                  <>
                    <Route path="/user" element={<User />} />
                    <Route path="/report" element={<Report />} />
                  </>
                }
              </Routes>
            </div>
          </div>
          : <Login />
      }
    </Router>
  );
}

export default App;
